import { render, staticRenderFns } from "./floating-actions.vue?vue&type=template&id=6a7cdaf1&scoped=true&"
import script from "./floating-actions.vue?vue&type=script&lang=js&"
export * from "./floating-actions.vue?vue&type=script&lang=js&"
import style0 from "./floating-actions.vue?vue&type=style&index=0&id=6a7cdaf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7cdaf1",
  null
  
)

export default component.exports